<template>
  <v-app data-extentions="true">
    <div class="smp ma-1 mt-4 ">
      <AdSmp />
      <SaveLayoutSmp
        :auto-save="autoSave"
        :last-save-time="lastSaveTime"
        :save="callSave"
        :saving="saving"
        style="width:100%;"
        @change="autoSave=$event"
      />
    </div>
    <div>
      <div class="view-main">
        <div class="sm-hide pb-4 px-3 mt-4 mx-8">
          <v-layout
            :style="`height: 60px;background-color: ${backgroundColor}`"
            align-center
            class=" ma-0 pa-0"
            d-flex
            justify-start
          >
            <div
              :style="`width:5px; height:100%;background-color:${accentColor}`"
              class="mr-4"
            />
            <div style="font-weight: bold;font-size: 18px;">
              資料編集
            </div>
          </v-layout>
        </div>
        <div
          class="sub-header-margin mx-sm-8 mx-2"
          flat
        >
          <div
            ref="titleelement"
            :style="`background-color:${cardBackgroundColor}`"
            class="mx-3 mt-3 px-2"
          >
            <v-text-field
              v-model="document.name"
              :background-color="cardBackgroundColor"
              :maxlength="inputLength.title"
              :style="{fontSize:fontSize*1.1+'px',fontWeight:'bold'}"
              class="grey-text hide-details ma-0"
              dense
              flat
              label="資料タイトルを入力する"
              single-line
              solo
            />
          </div>

          <div v-if="errorFileList.length !== 0">
            <v-alert
              class="ma-3"
              dense
              dismissible
              type="error"
              @click="errorFileList = []"
            >
              5MB以上のファイルは保存できません
            </v-alert>

            <div
              v-for="(inputImage, index) in errorFileList"
              :key="'error_' + index"
              class="image-input ma-2 horizontal-list pt-3 mx-8"
              style=" position: relative; display: flex;"
            >
              <v-img
                :src="inputImage.url"
                aspect-ratio="1"
                height="128"
                width="128"
              />
            </div>
            <hr>
          </div>

          <div
            ref="imagelist"
            class="horizontal-list pt-3 ml-1"
            :style="{ width: horizontalWidth + 'px' }"
          >
            <div
              v-if="isPremium"
              class="image-input ma-2"
            >
              <ImageInput
                :value="inputImages"
                @error="onErrorFile"
                @success="onSuccessFile"
              />
            </div>
            <div
              v-for="(inputImage, index) in inputImages"
              :key="'local_' + index"
              ref="imagehorizontal"
              class="image-input ma-2"
              style=" position: relative;  display: flex;"
            >
              <v-img
                :src="inputImage.url"
                aspect-ratio="1"
                height="128"
                width="128"
                @click="openGallery(inputImage)"
              />

              <v-btn
                color="secondary"
                fab
                height="20"
                style="position: absolute; right:-10px;top:-10px"
                width="20"
                @click.prevent="onClickFileDelete(inputImage)"
              >
                <img
                  src="../assets/close.png"
                  width="10"
                >
              </v-btn>
            </div>
            <div
              v-for="(img,index) in images"
              :key="'server_' + index"
              class="image-input ma-2"
              style=" position: relative;  display: flex;"
            >
              <v-img
                :src="img.src"
                aspect-ratio="1"
                height="128"
                width="128"
                @click="openGallery(img)"
              />

              <v-btn
                color="secondary"
                fab
                height="20"
                style="position: absolute; right:-10px;top:-10px"
                width="20"
                @click.prevent="deleteConfirm(img)"
              >
                <img
                  src="../assets/close.png"
                  width="10"
                >
              </v-btn>
            </div>
          </div>

          <v-textarea
            v-model="document.content"
            :background-color="backgroundColor"
            :class="'mx-4 mt-4 grey-text linespace'+lineSpaceSize"
            color="text"
            :maxlength="inputLength.description"
            :style="{fontSize:fontSize+'px'}"
            :height="$vuetify.breakpoint.mobile ?fullheight-530 :hideAppbar ? $vuetify.breakpoint.height-210 :$vuetify.breakpoint.height-550"
            counter
            dense
            flat
            no-resize
            label="資料詳細を入力する"
            solo
          />
        </div>
      </div>
      <div
        :class="`view-right-menu pc ${hideAppbar ? '':'smallarea'}`"
      >
        <SaveLayoutPc
          :auto-save="autoSave"
          :last-save-time="lastSaveTime"
          :save="callSave"
          :saving="saving"
          @change="autoSave=$event"
        />
        <div style="height: 100%;">
          <div
            v-if="!isPremium"
          >
            <AdPc />
          </div>
        </div>
      </div>
    </div>

    <LightBox
      ref="gallery"
      :media="galleryImages"
      :show-caption="false"
      :show-light-box="false"
    />
    <v-dialog
      v-model="deleteDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          削除確認
        </v-card-title>
        <v-card-text>
          指定の画像を削除してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="deleteDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="deleteItem(deleteItemData)"
          >
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import {mapState} from "vuex";
  import clonedeep from 'lodash.clonedeep'
  import config from "@/const"
  import AdSmp from '../component/AdSmp.vue';
  import AdPc from '../component/AdPc.vue';
  import ImageInput from '../component/ImageInput.vue';
  import LightBox from 'vue-image-lightbox'
  import 'vue-orgchart/dist/style.min.css'
  import axios from "axios";
  import firebase from "firebase/app";
  import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css'

  import SaveLayoutPc from '../component/SaveLayoutPc.vue';
  import SaveLayoutSmp from '../component/SaveLayoutSmp.vue';

  export default {
    name: "DocumentEdit",
    components: {
      LightBox,
      AdSmp,
      AdPc,
      ImageInput,
      SaveLayoutPc,
      SaveLayoutSmp
    },

    data() {
      return {
        fullheight: window.innerHeight,
        inputLength: config.INPUT_LENGTH.document,
        inputText: "",
        deleteDialog: false,
        deleteItemData: null,
        saving: false,
        saver: null,
        document: {},
        baseDocument: null,
        saveTimer: null,
        autoSave: null,
        images: [],
        deleteImageStack:[],
        inputImages: [],
        galleryImages: [],
        accentColor: null,
        backgroundColor: null,
        cardBackgroundColor: null,
        lastSaveTime: null,
        errorFileList: [],
        horizontalWidth: 0
      }
    },
    created() {
      window.addEventListener("beforeunload", this.leaveHandler);
    },
    destroyed() {
      window.removeEventListener("beforeunload", this.leaveHandler);
      window.removeEventListener('resize', this.getTargetWidth);
    },
    beforeRouteLeave(to, from, next) {
      if (this.hasDiff()) {
        // アラートダイアログを表示して、結果に応じて遷移
        const msg = "編集した内容が保存されていません。遷移しますか？";
        const answer = window.confirm(msg);
        next(answer);
      } else {
        // next()は必ず呼び出さないといけない
        next();
      }
    },
    mounted() {
      this.accentColor = this.$vuetify.theme.themes.light.secondary
      this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
      this.cardBackgroundColor = this.$vuetify.theme.dark ? '#050507' : '#fafaf8'
      if (localStorage.autoSave != null && localStorage.autoSave != undefined) {
        this.autoSave = localStorage.autoSave == "true";
      } else {
        this.autoSave = true;
      }
      // 要素の幅を取得するメソッド
      this.getTargetWidth()
      // ユーザーがウィンドウサイズを変更したら実行されるようにする
      window.addEventListener('resize', this.getTargetWidth)
    },
    methods: {
      getTargetWidth() {
        this.horizontalWidth = this.$refs.titleelement.clientWidth;
      },
      leaveHandler(event) {
        // 入力と保存に差分があったらブラウザのダイアログ
        if (this.hasDiff()) {
          event.preventDefault();
          event.returnValue = "編集した内容が保存されていません。遷移しますか？";
        }
      },
      callSave() {
        this.saver = 'saving'
      },
      deleteConfirm(deleteItemData) {
        this.deleteItemData = deleteItemData;
        this.deleteDialog = true;
      },
      // 削除実行
      async deleteItem() {
        this.deleteDialog = false;
        const user = firebase.auth().currentUser;
        const token = await user.getIdToken(false);
        if (token == null) {
          return
        }

        this.images = this.images.filter(value => value !== this.deleteItemData);
        this.deleteImageStack.push(this.deleteItemData);
        // const fileId = this.deleteItemData.id;
        // await axios.delete(
        //   config.API_URL + `auth/file/${this.baseDocument.id}/photos/${fileId}`, {
        //     headers: {"X-Firebase-Auth": token},
        //   });
        // this.lastSaveTime = Date.now()
        // this.inputImages = [];
        // this.saveTimer = null;
        // this.saver = null;
        // this.requestApi();
      },
      hasDiff() {
        if (this.baseDocument == undefined) {
          if (this.document.name || this.document.content || this.inputImages.length > 1)
            return true;
        } else {
          if (this.baseDocument.name != this.document.name) {
            return true
          }
          if (this.baseDocument.content != this.document.content) {
            return true
          }
          if (this.inputImages && this.inputImages.length > 0) {
            return true
          }
          if (this.deleteImageStack && this.deleteImageStack.length > 0){
            return true
          }
        }
        return false
      },
      openGallery(index) {
        this.galleryImages = this.inputImages.concat(this.images);
        const position = this.galleryImages.indexOf(index);
        this.$refs.gallery.showImage(position);
      },
      onSuccessFile(fileList) {
        this.inputImages = fileList;
      },
      onErrorFile(fileList) {
        this.errorFileList = fileList;
      },
      onClickFileDelete(file) {
        this.inputImages = this.inputImages.filter(value => value !== file);
      },
      async requestApi() {
        const user = firebase.auth().currentUser
        const token = await user.getIdToken(false)
        if (token == null) {
          return
        }
        try {
          if (this.$route.params.documentid != "create") {
            let ret = await axios.get(config.API_URL + "auth/file", {
              headers: {"X-Firebase-Auth": token},
              params: {
                "id": config.HASH_IDS.decode(this.$route.params.documentid)[0],
              },
              data: {}
            });
            this.baseDocument = ret.data
          }
        } catch (e) {
          this.$router.push({
            name: 'NovelIndex',
            params: {novelid: this.$route.params.novelid}
          })
        }
        this.document = clonedeep(this.baseDocument)
        if (this.document == undefined || this.document == null) {
          this.document = {
            novelId: config.HASH_IDS.decode(this.$route.params.novelid)[0]
          }
          return;
        }
        this.images = []

        const response = await axios.get(config.API_URL + `auth/file/${this.document.id}/photos`, {
          headers: {"X-Firebase-Auth": token},
        });


        this.images = response.data.map(value => {
          return {
            id: value.id,
            src: value.path,
            thumb: value.path,
            caption: '',
            name: value.path
          }
        });
      }
    },
    computed: {
      ...mapState({
        user: state => state.userModule.user,
        fontSize: state => state.userModule.user.writerFontSizeTypeKeyValue.size * 13,
        lineSpaceSize: state => state.userModule.user.writerLineSpaceTypeKeyValue.value,
        isPremium: state => state.userModule.isPremium,
        hideAppbar:state=>state.userModule.hideTopBottomMode
      }),
    },
    watch: {
      autoSave(newName) {
        localStorage.autoSave = newName;
        if (localStorage.autoSave && this.hasDiff()) {
          this.callSave()
        }
      },
      $route: {
        handler: async function () {
          this.requestApi();
        },
        immediate: true
      },

      document: {
        handler: function (val, oldVal) {
          if (this.autoSave) {
            if (this.hasDiff()) {
              if (this.saveTimer != null) {
                clearTimeout(this.saveTimer)
              }
              this.saveTimer = setTimeout(this.callSave, config.AUTO_SAVE_TIME)
            }
          }
        },
        deep: true
      },
      inputImages: {
        handler: function (val, oldVal) {
          if (this.autoSave) {
            if (this.hasDiff()) {
              if (this.saveTimer != null) {
                clearTimeout(this.saveTimer)
              }
              this.saveTimer = setTimeout(this.callSave, config.AUTO_SAVE_TIME)
            }
          }
        },
        deep: true
      },
      async saver() {
        if (this.saver != null) {

          const user = firebase.auth().currentUser
          const token = await user.getIdToken(false)
          if (token == null) {
            return
          }

          if (this.saveTimer != null) {
            clearTimeout(this.saveTimer)
          }

          const saveValues = clonedeep(this.document);
          saveValues.photo = '';
          saveValues.modifiedTimestamp = Date.now()
          saveValues.updateDate = Date.now()
          if (saveValues.createdDate == undefined) {
            saveValues.createdDate = Date.now()
          }


          const ret = await axios.post(config.API_URL + "auth/file", saveValues, {
            headers: {"X-Firebase-Auth": token, "fromWeb": true},
          }).catch(err => {
            alert("保存中にエラーが発生しました。もう一度保存してください");
            this.baseDocument = this.document
            this.saveTimer = null;
            this.saver = null;
            return
          });;
          this.document = ret.data

          history.replaceState('', '', config.HASH_IDS.encode(this.document.id));

          const uploadImages = clonedeep(this.inputImages)

          for (let i = 0; i < uploadImages.length; i++) {
            const file = uploadImages[i].file;
            const formData = new FormData();
            formData.append('upload_file', file);
            formData.append('file_id', this.document.id);
            formData.append('novelid', this.document.novelId);
            await axios.post(config.API_URL + "auth/file/photoUpload",
              formData, {
                headers: {
                  "X-Firebase-Auth": token,
                  'content-type': 'multipart/form-data'
                }
              }).then(_ => {
              this.inputImages.splice(i)
              this.images.unshift(uploadImages[i])
            }).catch(err => {
              alert("保存中にエラーが発生しました。もう一度保存してください");
              this.baseDocument = this.document
              this.saveTimer = null;
              this.saver = null;
              return
            });
          }

          const deleteImages = clonedeep(this.deleteImageStack);
          for(let i = 0; i < deleteImages.length; i++){
            const deleteImage = deleteImages[i];
            const fileId = deleteImage.id;
            await axios.delete(
              config.API_URL + `auth/file/${this.baseDocument.id}/photos/${fileId}`, {
                headers: {"X-Firebase-Auth": token},
              }).then(() =>  {
              this.deleteImageStack.slice(i);
            }).catch(err => {
              alert("保存中にエラーが発生しました。もう一度保存してください");
              this.baseDocument = this.document;
              this.saveTimer = null;
              this.saver = null;
              return
            });
          }

          this.baseDocument = this.document
          this.lastSaveTime = Date.now()
          // this.inputImages = [];
          this.saveTimer = null;
          this.saver = null;
        }
      }
    }
  }
</script>

<style>
    .sub-header-margin {
        height: 100vh;
        overflow: auto;
        /*padding-bottom: 136px;*/
    }

    .flex-container {
        display: flex;
        justify-content: flex-end;
    }

    .flex-container > :first-child {
        margin-right: auto;
    }

    .image-input {
        border: solid 1px var(--v-bordercolor-base);
        background-color: var(--v-background2-base);
    }

    .image-input__field {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .image-input__field.over {
        background-color: #666;
    }

    .image-input__field > input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        cursor: pointer;
    }

    .image-input__field > p {
        color: #aaa;
        text-align: center;
    }

    .horizontal-list {
        display: flex;
        overflow-x: auto;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
    }

    .horizontal-list-item {
        display: inline-block;
    }
</style>
